export const COMPANY = {
    name: "YATTO LLC",
    tagline: "Your Global Partner in Quality",
    email: "info@yattotrade.com",
    phones: ["360-583-7945", "832-807-0745"],
    serviceArea: "Texas & Nationwide Distribution",
};

export const fmtPrice = (v) =>
    v === null || v === undefined || v === "" ? null : `$${Number(v).toFixed(2)}`;
